import Link from 'next/link';

import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

import { FypBannerItem } from '@creoate/virgo-content-api';

import useResponsive from 'hooks/useResponsive';

import CustomImage from 'components/CustomImage';

interface BannerCardProps {
  testId?: number | null;
  banner: FypBannerItem;
}

const BannerCard = ({ testId, banner }: BannerCardProps) => {
  const { id, image, url, title } = banner;
  const isMobile = useResponsive('down', 'sm');

  return (
    <Grid data-testid={`fyp-banner-card-${testId}`} key={id} item sm={4} sx={{ mr: { xs: 0.5, sm: 0 } }}>
      <Link aria-label={title} href={url} passHref>
        <Card elevation={0}>
          <CustomImage
            src={image?.url}
            alt={title}
            width={430}
            height={200}
            sizes="100vw"
            unoptimized={false}
            sx={{
              borderRadius: '16px',
              minWidth: isMobile ? 300 : '',
              objectFit: 'contain',
              height: 'max-content',
              width: '100%',
            }}
          />
        </Card>
      </Link>
    </Grid>
  );
};

export default BannerCard;
